// extracted by mini-css-extract-plugin
export var border = "IntroWithImageTeal-module--border--aafe2";
export var bordersection = "IntroWithImageTeal-module--bordersection--b36b3";
export var herowithimagecontainer = "IntroWithImageTeal-module--herowithimagecontainer--75a22";
export var imagewrapper = "IntroWithImageTeal-module--imagewrapper--fd2e3";
export var subtitle = "IntroWithImageTeal-module--subtitle--4fe34";
export var textcontainer = "IntroWithImageTeal-module--textcontainer--7d462";
export var title = "IntroWithImageTeal-module--title--a9af2";
export var topsectionouter = "IntroWithImageTeal-module--topsectionouter--c0973";